import {
  ModalSheet,
  ModalSheetContent,
  ModalSheetContentBlock,
  ModalSheetContentIllustration,
  ModalSheetFooter,
  ModalSheetFooterButtonGroup,
  ModalSheetFooterSpacer,
  ModalSheetHeader,
  ModalSheetHeaderCloseButton,
} from '@/components/ModalSheet'
import { Button } from '@/components/Button'
import styles from './UnarchiveItemDialog.module.css'
import { byDesign } from '@/infra/design'
import imgJobCompletedUrl from '@/assets/misc/img_job-completed.svg'
import CompleteJobIllustration from '@/components/SpotIllustration/CompleteJobIllustration'

export interface UnarchiveItemDialogProps {
  showing: boolean
  onClose: () => unknown
  onUnarchive: () => unknown
  isUnarchivePending: boolean
  isOverride?: boolean
  inventoryItemName?: string
  workspaceName?: string
  corporateMode: boolean
  testId?: string
}

export function UnarchiveItemDialog({
  showing,
  onClose,
  onUnarchive,
  isUnarchivePending,
  isOverride,
  inventoryItemName,
  workspaceName,
  corporateMode,
  testId,
}: UnarchiveItemDialogProps) {
  const inventoryItemNameLength = inventoryItemName?.length ?? 0
  return (
    <ModalSheet
      showing={showing}
      onRequestClose={isUnarchivePending ? undefined : onClose}
    >
      <ModalSheetHeader>
        <div className={styles.closeButtonContainer}>
          <ModalSheetHeaderCloseButton
            testId={testId ? `${testId}-close-unarchive-modal` : undefined}
          />
        </div>
      </ModalSheetHeader>
      <ModalSheetContent>
        <ModalSheetContentBlock>
          {!corporateMode && (
            <ModalSheetContentIllustration
              src={imgJobCompletedUrl}
              illustration={byDesign(undefined, CompleteJobIllustration)}
              alt="Unarchive item"
            />
          )}
          <h3 className={styles.title}>
            {isOverride ? (
              <>
                You are about to unarchive this override of <br />
                {inventoryItemNameLength < 44 ? (
                  <span className={styles.inventoryItemName}>
                    {inventoryItemName}
                  </span>
                ) : (
                  inventoryItemName
                )}
              </>
            ) : (
              <>
                You are about to unarchive{' '}
                {inventoryItemNameLength < 44 ? (
                  <span className={styles.inventoryItemName}>
                    {inventoryItemName}
                  </span>
                ) : (
                  inventoryItemName
                )}
              </>
            )}
          </h3>
          <p className={styles.description}>
            {isOverride ? (
              'All legends in ' +
              (workspaceName ?? 'this workspace') +
              ' will need to be updated to reference the global version of this item.'
            ) : (
              <>
                All legends will be able to reference this service item.
                Existing legends can also be updated to utilize this service
                item.
              </>
            )}
          </p>
        </ModalSheetContentBlock>
      </ModalSheetContent>
      <ModalSheetFooter>
        <ModalSheetFooterSpacer />
        <ModalSheetFooterButtonGroup>
          <Button
            label="Cancel"
            isDisabled={isUnarchivePending}
            onPress={onClose}
            variant="default"
          />
          <Button
            label="Unarchive"
            onPress={onUnarchive}
            isPending={isUnarchivePending}
            isDisabled={isUnarchivePending}
            variant="primary"
            testId={testId ? `${testId}-unarchive-button` : undefined}
          />
        </ModalSheetFooterButtonGroup>
      </ModalSheetFooter>
    </ModalSheet>
  )
}
